import { formattedDate } from "@/lib/Util";

export function formateDate(value: string) {
    if (value) {
        return formattedDate(value);
    }
    return;
}